'use strict';

var _createForOfIteratorHelper = require("C:\\Users\\aarad\\Desktop\\Hackathons\\pre_terra\\client\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/createForOfIteratorHelper");

Object.defineProperty(exports, '__esModule', {
  value: true
});

var cid = require('multiformats/cid');

var toUrlSearchParams = require('../../lib/to-url-search-params.js');

var decodePin = function decodePin(_ref) {
  var name = _ref.Name,
      status = _ref.Status,
      cid$1 = _ref.Cid;
  return {
    cid: cid.CID.parse(cid$1),
    name: name,
    status: status
  };
};

var encodeService = function encodeService(service) {
  if (typeof service === 'string' && service !== '') {
    return service;
  } else {
    throw new TypeError('service name must be passed');
  }
};

var encodeCID = function encodeCID(cid$1) {
  if (cid.CID.asCID(cid$1)) {
    return cid$1.toString();
  } else {
    throw new TypeError("CID instance expected instead of ".concat(typeof cid$1));
  }
};

var encodeQuery = function encodeQuery(_ref2) {
  var service = _ref2.service,
      cid = _ref2.cid,
      name = _ref2.name,
      status = _ref2.status,
      all = _ref2.all;
  var query = toUrlSearchParams.toUrlSearchParams({
    service: encodeService(service),
    name: name,
    force: all ? true : undefined
  });

  if (cid) {
    var _iterator = _createForOfIteratorHelper(cid),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var value = _step.value;
        query.append('cid', encodeCID(value));
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  if (status) {
    var _iterator2 = _createForOfIteratorHelper(status),
        _step2;

    try {
      for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
        var _value = _step2.value;
        query.append('status', _value);
      }
    } catch (err) {
      _iterator2.e(err);
    } finally {
      _iterator2.f();
    }
  }

  return query;
};

var encodeAddParams = function encodeAddParams(_ref3) {
  var cid = _ref3.cid,
      service = _ref3.service,
      background = _ref3.background,
      name = _ref3.name,
      origins = _ref3.origins;
  var params = toUrlSearchParams.toUrlSearchParams({
    arg: encodeCID(cid),
    service: encodeService(service),
    name: name,
    background: background ? true : undefined
  });

  if (origins) {
    var _iterator3 = _createForOfIteratorHelper(origins),
        _step3;

    try {
      for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
        var origin = _step3.value;
        params.append('origin', origin.toString());
      }
    } catch (err) {
      _iterator3.e(err);
    } finally {
      _iterator3.f();
    }
  }

  return params;
};

exports.decodePin = decodePin;
exports.encodeAddParams = encodeAddParams;
exports.encodeCID = encodeCID;
exports.encodeQuery = encodeQuery;
exports.encodeService = encodeService;